import { Box, Container, Grid, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import banner from '../assets/home_img.png'
import publications from '../assets/publications.png'
import certifications from '../assets/certifications.png'
import about_2 from '../assets/about_2.png'
import tick from '../assets/arrow_right red.png';

export default function AboutPage() {
    return (
        <>
            <Box py={6} sx={{ background: '#FFFFFF' }}>
                <Container>
                    <Grid container spacing={6} alignItems='center'>

                        <Grid item xs={12} md={6}>
                            <Typography
                                fontWeight={600}
                                color="primary.main"
                            >
                            </Typography>
                            <Typography variant="h2" mb={1}>
                                About <Box component='span' color='primary.main'>Us</Box>
                            </Typography>
                            <Typography color='#77829D' lineHeight={1.7} textAlign="justify"
                                        sx={{ textJustify: 'inter-word' }}>
                                An Urgent care is US Base concept to provides immediate medical attention for non-life-threatening illnesses and injuries, such as Chest Pain, Breathing Difficulties, minor fractures, infections, cuts, burns, stomachache, and Flu symptoms. It serves as a convenient alternative to emergency rooms and OPDs, offering walk-in services with almost no wait times and lower costs. Urgent care centers typically operate beyond regular clinic hours, including evenings and weekends. We provide diagnostic services like X-rays and lab tests, ensuring prompt treatment without needing an appointment. Ideal for urgent but non-life threatning conditions medical needs, urgent care bridges the gap between primary care and emergency rooms.
                                <br/>
                                VEM Plus Urgent Care is a trusted medical facility committed to delivering high-quality and immediate healthcare services for patients in need of urgent attention. We specialize in addressing a wide range of non-life-threatening medical concerns, ensuring prompt diagnosis and treatment without the long wait times often associated with emergency rooms. Our dedicated team of experienced healthcare professionals is equipped to handle everything from minor injuries and illnesses to more pressing medical issues that require immediate care. At VEM Plus Urgent Care, we prioritize the well-being of our patients, offering compassionate, personalized treatment in a safe and welcoming environment. Whether it’s for adults, children, or seniors, we strive to provide efficient, affordable, and reliable healthcare when you need it most.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box
                                component='img'
                                src={about_2}
                                width={1}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>

    )
}

